export default __webpack_public_path__ + "static/media/modal_image.10f2a248.svg";